import React from 'react';

const OwnerPage = () => {
  return <div>Penitip History (Kosong)</div>;
};

export default OwnerPage;